export const routes = {
  home: {
    id: '1',
    name: 'Home',
    path: `/`,
    transKey: 'menu_home',
    authRequired: false,
    hideMenu: false,
    cookieRequired: false,
    event_name: 'homepage'
  },
  mypicks: {
    id: '2',
    name: 'MyPicks',
    path: `/mypicks`,
    transKey: 'menu_mypicks',
    authRequired: false,
    hideMenu: true,
    cookieRequired: false,
    event_name: 'mypicksPage',
    teamRequired: true
  },
  leaderboard: {
    id: '3',
    name: 'Leaderboard',
    path: `/leaderboard`,
    transKey: 'menu_leaderboard',
    authRequired: false,
    hideMenu: true,
    cookieRequired: false,
    event_name: 'leaderboardPage',
    teamRequired: true
  },

  playerlist: {
    id: '4',
    name: 'PlayerList',
    path: `/playerlist`,
    transKey: 'menu_playerlist',
    authRequired: false,
    hideMenu: false,
    cookieRequired: false,
    event_name: 'playerlistPage'
  },

  howtoplay: {
    id: '5',
    name: 'How to Play',
    path: `/howtoplay`,
    transKey: 'menu_howtoplay',
    authRequired: false,
    hideMenu: false,
    cookieRequired: false,
    event_name: 'howtoplayPage',
    teamRequired: false
  },
  rules: {
    id: '6',
    name: 'Rules',
    path: `/rules`,
    transKey: 'menu_Rules',
    authRequired: false,
    hideMenu: false,
    cookieRequired: false,
    event_name: 'RulesPage'
  },

  terms: {
    id: '7',
    name: 'Terms',
    path: `/terms`,
    transKey: 'menu_terms',
    authRequired: false,
    hideMenu: false,
    cookieRequired: false,
    event_name: 'termsPage'
  },
  // faqs: {
  //   id: '8',
  //   name: 'FAQs',
  //   path: `/faqs`,
  //   transKey: 'menu_faqs',
  //   authRequired: false,
  //   hideMenu: false,
  //   cookieRequired: false,
  //   event_name: 'faqsPage'
  // },
  createteam: {
    id: '8',
    name: 'createteam',
    path: `/createteam`,
    transKey: 'navigationTabCreateTeam',
    authRequired: false,
    hideMenu: true,
    cookieRequired: false,
    event_name: 'createteamPage'
  }
};

Object.freeze(routes);
